document.querySelectorAll('.entry-content[data-related-posts]').forEach((content) => {
  let relatedPosts;

  try {
    relatedPosts = JSON.parse(content.dataset.relatedPosts);
  } catch (error) {
    console.error('Unable to parse related posts data.', error);
    return;
  }

  if (!Array.isArray(relatedPosts)) {
    return;
  }

  const posts = relatedPosts.filter((post) => (
    post
        && typeof post.title === 'string'
        && post.title !== ''
        && typeof post.url === 'string'
        && post.url.startsWith('/blog/')
  ));

  if (posts.length === 0) {
    return;
  }

  const section = document.createElement('aside');
  section.className = 'related-posts';
  section.setAttribute('aria-labelledby', 'related-posts-title');

  const heading = document.createElement('p');
  heading.className = 'related-posts__title';
  heading.id = 'related-posts-title';
  heading.innerHTML = '<strong>Mehr zum Thema</strong>';

  const list = document.createElement('ul');
  list.className = 'related-posts__list';

  posts.forEach((post) => {
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = post.url;
    link.textContent = post.title;
    item.append(link);
    list.append(item);
  });

  section.append(heading, list);
  const paragraphs = content.querySelectorAll('p');
  if (paragraphs.length >= 3) {
    paragraphs[2].after(section);
  } else {
    content.append(section);
  }
});
